import { render, staticRenderFns } from "./ModifyBasicGrades.vue?vue&type=template&id=07bc96c8&scoped=true&"
import script from "./ModifyBasicGrades.vue?vue&type=script&lang=js&"
export * from "./ModifyBasicGrades.vue?vue&type=script&lang=js&"
import style0 from "./ModifyBasicGrades.vue?vue&type=style&index=0&id=07bc96c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc96c8",
  null
  
)

export default component.exports